import { Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';

const getFileExtension = (filename: any) => {
  return filename.split('.').pop().toLowerCase();
};

const CnhComponent: React.FC = () => {
  const frontCnhImage = useSelector(
    (state: ApplicationState) => state.driver?.driverLicense?.front,
  );

  const showContent = () => {
    if (frontCnhImage) {
      const extension = getFileExtension(frontCnhImage);
      if (extension === 'pdf') {
        return <iframe src={frontCnhImage} width="350px" />;
      } else if (
        extension === 'jpg' ||
        extension === 'jpeg' ||
        extension === 'png'
      ) {
        return <img src={frontCnhImage} alt="selfie" width="350px" />;
      }
    }
    return <Typography variant="body1">Sem imagem</Typography>;
  };

  return (
    <div style={{ display: 'flex' }}>
      <div className="cnh-container">{showContent()}</div>
      <RefuseSelect step={3} />
    </div>
  );
};

export default CnhComponent;
